import { useQuery } from '@apollo/client';

import { SpecialPiiNotice } from 'query/__generated__/specialPiiNotice';
import { SPECIAL_PII_NOTICE_QUERY } from 'query/specialPiiNotice';

export const SPECIAL_PII_NOTICE_TITLE = 'Special PII Notice';

export const PII_NOTICE_REQUIRED_REASON = 'pii_notice_required';

export type SpecialPiiNoticeState =
  | { status: 'ready'; version: string; text: string }
  | { status: 'loading' }
  | { status: 'refused' }
  | { status: 'failed'; retry: () => void };

// Exhibit 6 Attachment D comes from api: Exhibit 6 is controlled, so its text stays out of the
// public bundle. The version a user accepts is the one api served with the text they read.
export function useSpecialPiiNotice(): SpecialPiiNoticeState {
  const { data, loading, error, refetch } = useQuery<SpecialPiiNotice>(SPECIAL_PII_NOTICE_QUERY, {
    notifyOnNetworkStatusChange: true,
  });
  const notice = data?.specialPiiNotice;
  if (notice) {
    return { status: 'ready', version: notice.version, text: notice.text };
  }
  if (loading) {
    return { status: 'loading' };
  }
  // api refuses anyone without Level 2 access now; asking again won't change that.
  if (error?.graphQLErrors.some((graphQLError) => graphQLError.extensions?.code === 'FORBIDDEN')) {
    return { status: 'refused' };
  }
  return {
    status: 'failed',
    // A refetch that fails again comes back through `error` as this same state.
    retry: () => {
      refetch().catch(() => undefined);
    },
  };
}
